import axios from "axios";

const BASE_URL = 'https://apis.kokudrink.com/api/';

export default axios.create({
    baseURL: BASE_URL,
})